























































import Vue from 'vue'
import Component from "vue-class-component";
import { Action } from "vuex-class";
import { LoginCard } from 'wings-ui-components';
import { Ref } from "vue-property-decorator";
import {declOfForPasswordLength, declOfWords} from "@/utils/notify-utils";
import i18n from "@/plugins/i18n";
import {ErrorContext} from "@/store/lists/types";

@Component({components: { LoginCard }})
export default class ChangePassword extends Vue {
  private password = '';
  private confirm_password = '';
  private isProgress: boolean = false;
  private error: boolean = false;
  private errorMessage = '';
  @Action("changePassword") changePasswordAction:any;
  @Ref("validator") validator: any;

  async changePassword(){
    let valid: boolean = await this.validator.validate();
    if (valid) {
      this.isProgress = true;
      this.error = false;
      try {
        await this.changePasswordAction({password:this.password});
        this.$router.push(localStorage.getItem('lastUrl') || '/');
        this.error = false;
      } catch(e){
        this.error = true;
        let errorCode = parseInt(e?.response?.data.code ?? 1);
        let errorContext: ErrorContext = e?.response?.data?.errorContext;
        if (errorCode === 7) {
          this.errorMessage = this.$t('errors.incorrect_password').toString()
        } else if (errorCode === 16) {
          let symbols: string = declOfWords(parseInt(errorContext.minimalDifferentSymbolsNumber),"symbols");
          this.errorMessage = `${this.$t("errors.password_difference_symbols")} ${errorContext.minimalDifferentSymbolsNumber} ${symbols}`;
        } else if (errorCode === 17) {
          let symbols: string = declOfForPasswordLength(parseInt(errorContext.minimalPasswordLength));
          this.errorMessage = `${this.$t("errors.password_length")} ${errorContext.minimalPasswordLength} ${symbols}`;
        } else {
          this.errorMessage = this.$t('errors.internal').toString()
        }
      } finally {
        this.isProgress = false
      }
    } else {
      this.error = true;
      this.errorMessage=''
      if (this.validator.errors.new_password?.length) {
        for (let ec in this.validator.errors.new_password) {
          this.errorMessage += this.validator.errors.new_password[ec]
        }
      }
      if (this.validator.errors.confirm?.length) {
        for (let ec in this.validator.errors.confirm) {
          this.errorMessage += this.validator.errors.confirm[ec]
        }
      }
      setTimeout(() => this.error = false, 5000)
    }
  }

  async doLogout() {
    await this.$store.dispatch('authLogout')
    this.$router.push('/login')
  }
}
